import React from 'react';

const TheInfluencerTheme = {
  headerLogo: {
    src: '/themes/theme/the-influencer/logo.png',
    alt: 'The Content Club Logo',
    size: 40,
  },
  darkLogo: {
    src: '/themes/theme/the-influencer/logo.png',
    alt: 'The Content Club Logo',
    size: 70,
  },
  headerStyle: {
    backgroundColor: '#fff',
    borderBottom: '2px solid #000',
    height: 80,
  },
  linkStyle: {
    color: '#000',
    fontWeight: 800,
    fontSize: '120%',
  },
  title: 'Content Club',
  isLightOnDark: false,
  loginMessage: (
    <div style={{ padding: '10px' }}>
      <br /><br />
      <br /><br />
      <h3>Content Club</h3>
    </div>
  ),
  platformName: 'Content Club',
  shareSite: 'https://share.contentclub.es',
  organisationId: '04ae9be3-5130-4f6a-9344-34ca81e1f994',
  mediaKit: {
    avatarProps: {
      size: 'small',
      avatar: true,
      floated: 'left',
      style: {
        width: 150,
      },
    },
    logoProps: {
      floated: 'right',
      src: '/themes/theme/the-influencer/logo.png',
      style: {
        width: 400,
        marginTop: 35,
      },
    },
  },
};

export default TheInfluencerTheme;



/** WEBPACK FOOTER **
 ** ./src/themes/theme/the-influencer.js
 **/